import {Wallet, StatementItem, PaymentCurrencyType} from "@irati/types"
import walletService from "@irati/wallet/graph/wallet"

import {getStatementItems} from "../../graph/statementItem"
import DateGroupedStatementItems from "../../types/DateGroupedStatementItems"
import {knownStatementItemTypes} from "../../types/enums/StatementItemTypes"

export const LIST_STATEMENT_ITEMS = "LIST_STATEMENT_ITEMS"
export const CLEAR_STATEMENT_ITEMS = "CLEAR_STATEMENT_ITEMS"

export interface ListAction {
  type: typeof LIST_STATEMENT_ITEMS
  existingStatementItems: DateGroupedStatementItems[]
  newStatementItems: StatementItem[]
  newCursor: string
  currency: PaymentCurrencyType
}

export interface ClearAction {
  type: typeof CLEAR_STATEMENT_ITEMS
}

export type ActionTypes = ListAction | ClearAction

const list = (existingStatementItems: DateGroupedStatementItems[], newStatementItems: StatementItem[], newCursor: string) => {
  return {
    type: LIST_STATEMENT_ITEMS,
    existingStatementItems,
    newStatementItems,
    newCursor
  }
}

const clear = () => {
  return {
    type: CLEAR_STATEMENT_ITEMS
  }
}

export const listStatementItems = (
  existingStatementItems: DateGroupedStatementItems[],
  wallet: Wallet,
  limit: number,
  cursor?: string
) => {
  return (dispatch: (action: any) => void) => {
    const {ownerUuid, uuid, currency} = wallet
    return currency === PaymentCurrencyType.Rp
      ? walletService
          .statementItems({walletId: uuid!, cursor, knownTypes: knownStatementItemTypes}, {fetchPolicy: "network-only"})
          .then(({results, cursor: newCursor}) => {
            return dispatch(list(existingStatementItems, results, newCursor))
          })
      : getStatementItems(ownerUuid!, uuid!, cursor, limit, knownStatementItemTypes).then(({results, cursor: newCursor}) => {
          return dispatch(list(existingStatementItems, results, newCursor))
        })
  }
}

export const clearStatementItems = () => {
  return (dispatch: (action: any) => void) => dispatch(clear())
}

export default {
  list: listStatementItems,
  clear: clearStatementItems
}
